import type { Message } from '@efdigital/ll-addon-data';
import { DataTypeXceed } from '@efdigital/ll-addon-data/data-types';
import type { ProgramsProgramCohortMessagesCategoryModel } from '@efdigital/ll-admin-v2/routes/programs/program/cohort/messages/category';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

export type ProgramsProgramCohortMessagesCategoryNewModel =
  ProgramsProgramCohortMessagesCategoryModel & {
    message: Message;
  };

export default class ProgramsProgramCohortMessagesCategoryNewRoute extends Route<ProgramsProgramCohortMessagesCategoryNewModel> {
  @service declare store: Store;

  model() {
    const parentModel = this.modelFor(
      'programs.program.cohort.messages.category'
    ) as ProgramsProgramCohortMessagesCategoryModel;

    const message = this.store.createRecord<Message>(DataTypeXceed.Message, {
      cohort: parentModel.cohort,
      category: parentModel.category,
      title: '',
      markdown: '',
      startDate: undefined,
    });

    return {
      ...parentModel,
      message,
    };
  }
}
